import dayjs from "dayjs";
import { AccountDetailsValues, AccountField } from "../ProfilePageTypes";

export const AccountDetailsValidation = (values: AccountDetailsValues) => {
  const fields: AccountField[] = [
    {
      name: "first_name",
      label: "First Name",
      type: "enter",
    },
    // {
    //   name: "last_name",
    //   label: "Last Name",
    //   type: "enter",
    // },
    {
      name: "phone_number",
      label: "Mobile Number",
      type: "enter",
    },
    {
      name: "dob",
      label: "Date of birth",
      type: "choose",
    },
  ];

  let errors: Partial<AccountDetailsValues> = {};

  fields.forEach((field) => {
    const value = values[field?.name]?.trim() || "";

    if (!value) {
      errors[field.name] = `Please ${field.type} ${field.label}.`;
    } else if (field.name === "phone_number") {
      const mobileNumberRegex = /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/;
      if (!mobileNumberRegex.test(value)) {
        errors[field.name] = `Please enter a valid ${field.label}.`;
      }
    } else if (field.name === "dob") {
      const dob = dayjs(value);
      const minDate = dayjs().subtract(100, "year");
      const maxDate = dayjs().subtract(5, "year");

      if (!dob.isValid()) {
        errors[field.name] = `Please ${field.type} valid ${field.label}.`;
      } else if (dob.isBefore(minDate) || dob.isAfter(maxDate)) {
        errors[field.name] = `Please ${field.type} valid ${field.label}.`;
      }
    }
  });

  // Email validation - required like first name
  const emailVal = values?.email?.trim() || "";
  if (!emailVal) {
    errors.email = `Please enter a valid email.`;
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailVal)) {
      errors.email = "Please enter a valid email address.";
    }
  }

  return errors;
};

export const AccountNameDetailsValidation = (values: AccountDetailsValues) => {
  const fields: AccountField[] = [
    {
      name: "first_name",
      label: "First Name",
      type: "enter",
    },
  ];

  let errors: Partial<AccountDetailsValues> = {};

  fields.forEach((field) => {
    const value = values[field?.name]?.trim() || "";

    if (!value) {
      errors[field.name] = `Please Enter The Name.`;
    }
  });

  return errors;
};
